type Ships = {[key: string]: Ship}
type Ship = {
    amount: number | null
    weapon: number
    shield: number
    armor: number
    cargo: number
    speed: number
    fuel: number
}

function defaultShips(): Ships {
    return {
        "202": defaultShip(),
        "203": defaultShip(),
        "204": defaultShip(),
        "205": defaultShip(),
        "206": defaultShip(),
        "207": defaultShip(),
        "208": defaultShip(),
        "209": defaultShip(),
        "210": defaultShip(),
        "211": defaultShip(),
        "213": defaultShip(),
        "214": defaultShip(),
        "215": defaultShip(),
        "218": defaultShip(),
        "219": defaultShip()
    }
}

function defaultShip(): Ship {
    return {
        amount: null,
        weapon: 0,
        shield: 0,
        armor: 0,
        cargo: 0,
        speed: 0,
        fuel: 0,
    }
}

type Techs = {
    '109': number | null
    '110': number | null
    '111': number | null
    '114': number | null
    '115': number | null
    '117': number | null
    '118': number | null
}

const CombatTechs: (keyof Techs)[] = ['109', '110', '111']
const DriveTechs: (keyof Techs)[] = ['115', '117', '118']

function defaultTechs(): Techs {
    return {
        '109': null,
        '110': null,
        '111': null,
        '114': null,
        '115': null,
        '117': null,
        '118': null
    }
}

type Coordinates = {
    galaxy: number | null,
    system: number | null,
    position: number | null,
}

type Resources = {
	metal: number | null
	crystal: number | null
	deuterium: number | null
	food: number | null
}

function defaultResources(): Resources {
    return {
        metal: null,
        crystal: null,
        deuterium: null,
        food: null
    }
}

type ResourceKeys = (keyof Resources)
const ResourceMembers: ResourceKeys[] = ['metal', 'crystal', 'deuterium', 'food']

type Defenses = {[key: string]: Defense}
type Defense = {
    amount: number | null
    weapon: number
    shield: number
    armor: number
}

function defaultDefenses(): Defenses {
    return {
        "401": defaultDefense(),
        "402": defaultDefense(),
        "403": defaultDefense(),
        "404": defaultDefense(),
        "405": defaultDefense(),
        "406": defaultDefense(),
        "407": defaultDefense(),
        "408": defaultDefense()
    }
}

function defaultDefense(): Defense {
    return {
        amount: null,
        weapon: 0,
        shield: 0,
        armor: 0
    }
}

type Missiles = {[key: string]: Missile}
type Missile = {
    amount: number | null
}

function defaultMissiles() {
    return {
        '502': defaultMissile(),
        '503': defaultMissile()
    }
}

function defaultMissile(): Missile {
    return { amount: null }
}

export type {
    Ship,
    Ships,
    Techs,
    Coordinates,
    Resources,
    ResourceKeys,
    Defense,
    Defenses,
    Missile,
    Missiles
}

export {
    CombatTechs,
    DriveTechs,
    ResourceMembers,
}

export {
    defaultShip,
    defaultShips,
    defaultTechs,
    defaultResources,
    defaultDefense,
    defaultDefenses,
    defaultMissile,
    defaultMissiles
}